import URL from './url'
import http from '@/utils/httpUtils'

export default {
  // 提交调代课申请
  saveApplication(params) {
    return http.post(URL.API_SCHEDULE_SUBSTITUTE_APPLICATION, params)
  },
  // 查询班级列表（支持按校区、年级查询，支持指定显示在最前面的班级DingId）
  getSubstituteQueryClass(params) {
    return http.post(URL.API_SCHEDULE_SUBSTITUTE_QUERYCLASS, params)
  },
  // 校验调代课详情中是否有已经被关联的课程
  checkExistSubstituteSection(params) {
    return http.post(
      URL.API_SCHEDULE_SUBSTITUTE_CHECKEXISTSUBSTITUTESECTION,
      params
    )
  },
  // 安排调代课
  saveArrange(params) {
    return http.post(URL.API_SCHEDULE_SUBSTITUTE_ARRANGE, params)
  },
  // 删除调代课申请
  deleteApplication(params) {
    return http.post(URL.API_SCHEDULE_SUBSTITUTE_DELETE, params)
  },
  // 查询班级课表
  getClassSchedule(params) {
    return http.post(URL.API_SCHEDULE_SUBSTITUTE_GETCLASSSCHEDULE, params)
  },
  // 查询调代课申请详情
  substituteGetDetail(params) {
    return http.post(URL.API_SCHEDULE_SUBSTITUTE_GETDETAIL, params)
  },
  // 查询调代课个人统计汇总
  substituteGetPersonalStatistics(params) {
    return http.post(URL.API_SCHEDULE_SUBSTITUTE_GETPERSONALSTATISTICS, params)
  },
  // 查询老师课表
  substituteGetTeacherSchedule(params) {
    return http.post(URL.API_SCHEDULE_SUBSTITUTE_GETTEACHERSCHEDULE, params)
  },
  // 查询老师节次列表（某学期一段时间内的课表）
  substituteGetTeacherSectionList(params) {
    return http.post(URL.API_SCHEDULE_SUBSTITUTE_GETTEACHERSECTIONLIST, params)
  },
  // 查询调代课明细列表
  substituteListItem(params) {
    return http.post(URL.API_SCHEDULE_SUBSTITUTE_LISTITEM, params)
  },
  // 查询调代课老师统计汇总
  getTeacherStatistics(params) {
    return http.post(URL.API_SCHEDULE_SUBSTITUTE_GETTEACHERSTATISTICS, params)
  },
  // 分页查询调代课申请列表
  substituteListPage(params) {
    return http.post(URL.API_SCHEDULE_SUBSTITUTE_LISTPAGE, params)
  },

  // 根据班级id和节次信息查询班级任课老师（包含是否存在冲突）
  queryClassTeacherWithConflict(params) {
    return http.post(
      URL.API_SCHEDULE_SUBSTITUTE_QUERYCLASSTEACHERWITHCONFLICT,
      params
    )
  },
  // 根据课程id和节次信息查询老师列表（包含是否存在冲突）
  queryCourseTeacherWithConflict(params) {
    return http.post(
      URL.API_SCHEDULE_SUBSTITUTE_QUERYCOURSETEACHERWITHCONFLICT,
      params
    )
  },
  // 提交调代课申请
  substituteUpdateStatus(params) {
    return http.post(URL.API_SCHEDULE_SUBSTITUTE_UPDATESTATUS, params)
  },
  // 查询教师课表出现班级的最大节次数
  getMaxSectionNum(params) {
    return http.get(URL.API_SCHEDULE_TEACHER_GETMAXSECTIONNUM, params)
  },
  // 搜索任课老师（包含是否存在冲突）
  searchteacherwithconflict(params) {
    return http.post(
      URL.API_SCHEDULE_SUBSTITUTE_SEARCHTEACHERWITHCONFLICT,
      params
    )
  }
}
